/**
 * Chrome caps persistent cookies at ~400 days; use that as the practical maximum.
 * @see https://chromestatus.com/feature/4887741241229312
 */
export const AGE_CONFIRMATION_COOKIE_NAME = 'molwe_age_confirmed';
export const AGE_CONFIRMATION_COOKIE_MAX_AGE = 60 * 60 * 24 * 400;
export const AGE_CONFIRMATION_COOKIE_VALUE = 'true';
